import React from "react";
import "./Input.css";

const Input = props => {
  return (
    <div className="inputClass">
      <label htmlFor={props.type}>{props.label}</label>
      {props.editable ? (
        <input
          type={props.type}
          name={props.name}
          onChange={props.onChange}
          value={props.value}
        />
      ) : (
        <input
          className="nonEditable"
          type={props.type}
          name={props.name}
          onChange={props.onChange}
          value={props.value}
          disabled
        />
      )}
    </div>
  );
};

export default Input;
